import React from 'react'
import Breadcrumb from '../BreadCrumb/BreadCrumb'
import ContactOne from '../container/Contact/ContactOne'
import Footer from '../footer/Footer'
import MainNavigation from '../nav/MainNavigation'
import SEO from '../SEO/SEO'

export default function Contact() {
    return (
        <React.Fragment>
            <SEO title="Dr Bupathi Gastro and Laparoscopy || Contact Us" />
            <MainNavigation />
            <Breadcrumb image="/images/pages/blog.jpg" title="Home" content="Contact Us" />
            <ContactOne />
            {/* <HomeContact/> */}
            <Footer />
        </React.Fragment>
    )
}
